import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";
import SubSection from "../../SubSection";
import Section from "../../Section";
import { UIPortal } from "@solidwhite/ui-portal";
import { Airport } from "./Airport";
import { C_Automotive } from "./C-Automotive";
import { Logistic } from "./Logistic";
import { Amusement } from "./Amusement";
import ChargeIndustriesApplicationsUI from "../../../ui/Sections/Industries/ChargeIndustriesApplicationsUI";
import VisibleWithEbbne from "../../VisibleWithEbbne";
import { Suspense } from "react";
import LoadingCallback from "../../../LoadingCallback";

const ChargeIndustries = ({ nodes }) => {
  return (
    <Ebbne id="c-industries">
      <group position={nodes.industries.position} rotation={nodes.industries.rotation}>
        <Section object3d={nodes.industries} />

        <Ebbne id="amusement" visibleWithAbove={2}>
          <SubSection object3d={nodes.Amusement} />

          <MountWithEbbne>
            <Suspense fallback={null}>
              <Amusement />
            </Suspense>

            <UIPortal>
              <ChargeIndustriesApplicationsUI key="amusement_applications" industryId="amusement" />
            </UIPortal>
          </MountWithEbbne>
        </Ebbne>

        <Ebbne id="logistic" visibleWithAbove={2}>
          <SubSection object3d={nodes.Logistic} />

          <MountWithEbbne>
            <Suspense fallback={null}>
              <Logistic />
            </Suspense>
            <UIPortal>
              <ChargeIndustriesApplicationsUI key="logistic_applications" industryId="logistic" />
            </UIPortal>
          </MountWithEbbne>
        </Ebbne>

        <Ebbne id="airport" visibleWithAbove={2}>
          <SubSection object3d={nodes.Airport} />

          <MountWithEbbne>
            <Suspense fallback={null}>
              <Airport />
            </Suspense>

            <UIPortal>
              <ChargeIndustriesApplicationsUI key="airport_applications" industryId="airport" />
            </UIPortal>
          </MountWithEbbne>
        </Ebbne>

        <Ebbne id="c-automotive" visibleWithAbove={2}>
          <SubSection object3d={nodes.Automotive} />

          <MountWithEbbne>
            <Suspense fallback={null}>
              <C_Automotive />
            </Suspense>
            <UIPortal>
              <ChargeIndustriesApplicationsUI key="c-automotive_applications" industryId="c-automotive" />
            </UIPortal>
          </MountWithEbbne>
        </Ebbne>
      </group>
    </Ebbne>
  );
};

export default ChargeIndustries;
